export enum FeedingStage {
    PreStarter = 1,
    Starter = 2,
    Grower = 3,
    Finisher = 4
  }